import React from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import reactMixin from 'react-mixin';
import styles from './ProfilePage.scss';
import baseComponent from '../../decorators/baseComponent';
import Context from '../../Context';
import Header from '../Header';
import BaseReactComponent from '../Util/BaseReactComponent';
import { updateInstallerCompany } from '../../actioncreators/ZehnderActions';
import { connect } from 'react-redux';
import LinkedStateMixin from 'react-addons-linked-state-mixin';
import { Form, ValidatedInput } from 'react-bootstrap-validation';
import messages from '../../messages';
import { DropDownMenu, MenuItem } from 'material-ui';
import LanguageList from '../Util/LanguageList';
import { loadInstallerCompany } from '../../actioncreators/InstallerCompanyActions';

@connect(state => ({
  login: state.login.user,
  installerCompany: state.installerCompany.installerCompany
}))
@baseComponent(styles)
@reactMixin.decorate(LinkedStateMixin)
class ChangePasswordPage extends BaseReactComponent {
  constructor(props) {
    super(props);

    this.state = {};
    this.state.user = this.props.installerCompany; //JSON.parse(JSON.stringify();
    this.state.languages = Object.keys(messages.locales) || [];

    // if (typeof localStorage === 'undefined' ) {
    //   var localStorage = {getItem:function(){
    //     return undefined;
    //   }};
    // }

    if (
      typeof localStorage !== 'undefined' &&
      localStorage.getItem('preferedLanguage') !== undefined &&
      localStorage.getItem('preferedLanguage') !== null
    ) {
      this.state.languageI = this.state.languages.indexOf(localStorage.getItem('preferedLanguage'));
    } else {
      this.state.languageI = this.state.languages.indexOf('en');
    }
  }

  componentDidMount() {
    let roles = this.props.login.roles;

    if (roles !== undefined && roles.includes('INSTALLER_COMPANY') && !roles.includes('ZEHNDER')) {
      loadInstallerCompany(this.props.login.id)(this.props.dispatch);
    }
  }

  componentWillUpdate(nextProps) {
    if (nextProps.installerCompany && (this.state.user === undefined || Object.keys(this.state.user).length === 0)) {
      this.setState({ user: nextProps.installerCompany });
    }
  }

  keyup(e) {
    if (e.which === 13) {
      this.changePassword(e);
    }
  }

  updateUser() {
    let self = this;

    let roles = this.state.user ? this.state.user.roles : [];
    let isInstallerCompany = roles !== undefined && roles.includes('INSTALLER_COMPANY') && !roles.includes('ZEHNDER');

    if (isInstallerCompany) {
      updateInstallerCompany(this.state.user, function() {
        self.context.router.push('/');
      })(this.props.dispatch);
    }

    localStorage.setItem('preferedLanguage', this.state.languages[this.state.languageI]);

    if (typeof window !== 'undefined' && window.location) {
      window.location.replace('/');
    }
  }

  cancelChange() {
    this.context.router.push('/');
  }

  handleChange(key, event) {
    let user = JSON.parse(JSON.stringify(this.state.user));
    user[key] = event.currentTarget.value;
    this.setState({ user: user });
  }

  pickedLanguage = (event, languageI) => {
    this.setState({ languageI: languageI });
  };

  render() {
    let title = 'Profile';
    Context.getInstance().onSetTitle(title);
    if (typeof document !== 'undefined') {
      document.title = title;
    }

    let css = {
      borderTop: 'solid 1px #e0e0e0',
      bottom: '1px',
      left: '0',
      margin: '0',
      right: '0',
      position: 'absolute'
    };

    let menuItems = this.state.languages.map(function(language, index) {
      let country = LanguageList.find(l => l.id === language);

      if (country === undefined) {
        return <MenuItem key={index} value={index} primaryText={language} />;
      } else {
        return <MenuItem key={index} value={index} primaryText={country.display} />;
      }
    });

    let roles = this.props.login ? this.props.login.roles : [];
    let isInstallerCompany = roles !== undefined && roles.includes('INSTALLER_COMPANY') && !roles.includes('ZEHNDER');

    let requestForm = (
      <Form
        role="form"
        className="form-horizontal"
        onKeyPress={this.keyup.bind(this)}
        onValidSubmit={this.updateUser.bind(this)}>
        {isInstallerCompany
          ? [
              <div className="form-group">
                <label htmlFor="companyName" className="col-sm-2 control-label">
                  {this.getMessage('companyName-label')}
                </label>

                <div className="col-sm-6">
                  <ValidatedInput
                    name="companyName"
                    type="text"
                    className="validate"
                    id="username"
                    onChange={this.handleChange.bind(this, 'companyName')}
                    value={this.state.user.companyName}
                    validate="required"
                    errorHelp={{
                      required: 'Please enter the name of the company'
                    }}
                  />
                </div>
              </div>,
              <div className="form-group">
                <label htmlFor="address" className="col-sm-2 control-label">
                  {this.getMessage('address-label')}
                </label>

                <div className="col-sm-6">
                  <ValidatedInput
                    name="address"
                    type="text"
                    className="validate"
                    id="address"
                    onChange={this.handleChange.bind(this, 'address')}
                    value={this.state.user.address}
                  />
                </div>
              </div>,
              <div className="form-group">
                <label htmlFor="email" className="col-sm-2 control-label">
                  {this.getMessage('email-label')}
                </label>

                <div className="col-sm-6">
                  <ValidatedInput
                    name="email"
                    type="text"
                    className="validate"
                    id="email"
                    onChange={this.handleChange.bind(this, 'email')}
                    value={this.state.user.email}
                    validate="isEmail"
                    errorHelp={{
                      isEmail: 'Email is invalid'
                    }}
                  />
                </div>
              </div>
            ]
          : false}
        <div className="form-group">
          <label htmlFor="name" className="col-sm-2 control-label">
            {this.getMessage('language-label')}
          </label>

          <div className="col-sm-6 no-padding dropdown-choice">
            <DropDownMenu
              onChange={(e, i) => {
                this.pickedLanguage(e, i);
              }}
              autoWidth={true}
              value={this.state.languageI}
              underlineStyle={css}>
              {menuItems}
            </DropDownMenu>
          </div>
        </div>
        <div className="controls">
          <button className="btn btn-primary">{this.getMessage('save-button')}</button>
          <a className="btn btn-link" onClick={this.cancelChange.bind(this)}>
            {this.getMessage('cancel-button')}
          </a>
        </div>
      </Form>
    );

    return (
      <div className="ChangePasswordPage">
        <Header pageName="forgotpasswordpage" />

        <div className="ChangePasswordPage-container">
          <div className="ChangePasswordPage-header-row">
            <div className="container">
              <div className="col-xs-12">
                <h1>{this.getMessage('title')}</h1>
              </div>
            </div>
          </div>

          <div className="container">
            <div className="ChangePasswordPage-container-background">{requestForm}</div>
          </div>
        </div>
      </div>
    );
  }
}

ChangePasswordPage.defaultProps = {
  componentName: 'profilepage'
};

export default ChangePasswordPage;



// WEBPACK FOOTER //
// /src/components/ProfilePage/ProfilePage.js